import { COMPLETED, LOADING, UNINITIALIZED, ERROR, BROKER_PRODUCT } from '../store/actions/types';

const initialState = {
  status: UNINITIALIZED,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${BROKER_PRODUCT}_${COMPLETED}`:
      return {
        ...state,
        status: COMPLETED,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    case `${BROKER_PRODUCT}_LIMITS`:
      return {
        ...state,
        status: COMPLETED,
        data: {
          ...state.data,
          data: {
            ...state.data.data,
            notificationUrls: {
              ...state.data.data.notificationUrls,
              ...action.payload,
            },
          },
        },
      };
    case `${BROKER_PRODUCT}_LOGO`:
      return {
        ...state,
        status: COMPLETED,
        data: {
          ...state.data,
          data: {
            ...state.data.data,
            logo: [...state.data.data.styles, ...action.payload],
          },
        },
      };

    case `${BROKER_PRODUCT}_STYLES`:
      return {
        ...state,
        status: COMPLETED,
        data: {
          ...state.data,
          data: {
            ...state.data.data,
            styles: action.payload.reduce(
              (acc, newStyle) => {
                const existingStyleIndex = acc.findIndex((style) => style.type === newStyle.type);
                if (existingStyleIndex !== -1) {
                  acc[existingStyleIndex] = newStyle;
                } else {
                  acc.push(newStyle);
                }
                return acc;
              },
              [...state.data.data.styles]
            ),
          },
        },
      };
    case `${BROKER_PRODUCT}_SELECTED`:
      return {
        ...state,
        status: COMPLETED,
        data: action.payload,
      };
    case `${BROKER_PRODUCT}_${LOADING}`:
      return {
        ...state,
        status: LOADING,
        data: undefined,
      };
    case `${BROKER_PRODUCT}_${UNINITIALIZED}`:
      return {
        ...state,
        status: UNINITIALIZED,
        data: undefined,
      };
    case `${BROKER_PRODUCT}_${ERROR}`:
      return {
        ...state,
        status: ERROR,
        data: undefined,
      };
    default:
      return state;
  }
};
